import { OptionModel } from "../../common/types/OptionModel";

export const orderResource: OptionModel[] = [
    { 
        value: 1, 
        label: "Portal" 
    },
    { 
        value: 2, 
        label: "Ödeme Linki" 
    },
    { 
        value: 3, 
        label: "Mobil" 
    },
    // { 
    //     value: 4, 
    //     label: "QR Kod" 
    // },
    // { 
    //     value: 5, 
    //     label: "Whatsapp" 
    // },
    { 
        value: 6, 
        label: "Üyeliksiz" 
    },
    { 
        value: 8, 
        label: "Api" 
    },
]